export default __webpack_public_path__ + "static/media/adobeaudition.dd56aeda.svg";